export default "<small  class=\"vmessage text-danger text-left d-block mt-2\"> {{text}} </small>";